// modules
import mirrorCreator from 'mirror-creator';

// axios
import http from '../http';

export const actionTypes = mirrorCreator([
  'GET_SUPPORTS_REQUEST',
  'GET_SUPPORTS_RESPONSE'
]);

const API_PATH = 'supports/';

export function getSuports(params){
  return dispatch => {
    dispatch({type: actionTypes.GET_SUPPORTS_REQUEST, payload: params});
    http.get(API_PATH, params)
      .then(function (response) {
        dispatch({type: actionTypes.GET_SUPPORTS_RESPONSE, payload: response.data});
      })
      .catch(function (error) {
        if (process.env.NODE_ENV !== 'production') { console.log(error); }
      });
  };
}
